<template>
  <v-layout justify-space-around align-content-center wrap row fill-height>
    <v-flex xs12></v-flex>

    <v-flex xs12>
      <center>
        <img class="logo" src="@/assets/dbtracklogo.png" height="90px;">
      </center>
    </v-flex>

    <v-flex xs12 sm8 md5 lg4 xl3>
      <v-card class="elevation-12">
        <!-- <v-toolbar dark class="toolbar-title green-line">
          <v-toolbar-title>{{ $t('login.message') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn slot="activator" icon large target="_blank">
              <v-icon large>help</v-icon>
            </v-btn>
            <span>{{ $t('help') }}</span>
          </v-tooltip>
        </v-toolbar>-->

        <login-options v-if="mode == 'all'" @select-email="mode='mail'"/>
        <login-email v-if="mode == 'mail'" @view-all="mode='all'"/>
      </v-card>
    </v-flex>

    <v-flex xs12></v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import LoginOptions from "@/widgets/login/options";
import LoginEmail from "@/widgets/login/email";

export default {
  components: {
    "login-options": LoginOptions,
    "login-email": LoginEmail
  },
  data() {
    return {
      mode: "all"
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      authState: "auth/state"
    })
  },
  async mounted() {
    if (this.authenticated) {
      console.log(
        "landed on login page, but authenticated. This should not happen"
      );
      // this.$router.push('/')
      return;
    }
  }
};
</script>
<style scoped>
.logo {
  margin-bottom: 30px;
}
.toolbar-title {
  height: 80px;
  padding: 10px;
}
</style>

